// // import styled from 'styled-components';
// // import { darken } from 'polished';

// // export const CartModal = styled.div.attrs((props) => ({
// //   style: {
// //     top: `${props.top}px`,
// //     left: `${props.left}px`,
// //   },
// // }))`
// //   position: absolute;
// //   min-width: 400px;
// //   min-height: 250px;

// //   display: flex;
// //   flex-direction: column;
// //   box-shadow: 0px 3px 10px #00000033;
// //   background: #fff;
// //   border-radius: 10px;

// //   color: #2c405a;
// // `;

// // export const WrapperItemOS = styled.div`
// //   margin: 10px 0;
// //   padding: 10px;
// //   border-radius: 5px;
// //   box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
// // `;

// // export const SubtitleItemOS = styled.span`
// //   color: #0ea5e9 !important;
// //   font-weight: bold;
// //   padding: 10px;
// // `;

// // export const Content = styled.div`
// //   flex: 1;
// //   display: flex;
// //   flex-direction: column;
// //   padding: 30px 25px 25px;
// //   position: relative;
// // `;

// // Content.Move = styled.span`
// //   position: absolute;
// //   top: 0;
// //   left: 0;
// //   right: 0;
// //   margin: 0 auto;

// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   width: 80px;
// //   transition: 1s all;
// //   cursor: grab;

// //   :hover {
// //     color: #ff6d3c;
// //   }

// //   :active {
// //     cursor: grabbing;
// //   }
// // `;

// // Content.BtnClose = styled.button`
// //   position: absolute;
// //   top: 0;
// //   right: 0;
// //   margin: 2px;
// //   height: 30px;
// //   width: 30px;

// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   color: #cbd0d8;
// //   border: 0;
// //   background: none;
// //   transition: 1s all;

// //   :hover {
// //     color: ${darken(0.05, '#cbd0d8')};
// //   }
// // `;

// // Content.BtnAddCart = styled.button`
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   background: #ff6d3c;
// //   border: 0;
// //   border-radius: 5px;
// //   color: #fff;
// //   height: 40px;
// //   transition: background 1s;

// //   > svg {
// //     margin-right: 5px;
// //   }

// //   :hover {
// //     background: ${darken(0.05, '#ff6d3c')};
// //   }
// // `;

// // Content.Title = styled.div`
// //   position: relative;
// //   display: flex;
// //   flex-direction: column;
// //   width: 100%;
// //   color: #2c405a;

// //   user-select: text;

// //   > strong {
// //     font-size: 16px;
// //   }
// // `;

// // Content.Title.Espec = styled.span`
// //   color: rgba(44, 64, 90, 0.5);
// //   font-style: italic;
// // `;

// // Content.Title.Note = styled.div`
// //   border-radius: 5px;
// //   background: #f8f8f8;
// //   padding: 5px 10px;
// //   color: rgba(44, 64, 90, 0.5);
// //   text-align: center;
// //   font-size: 12px;
// //   margin-top: 5px;
// // `;

// // Content.Form = styled.div`
// //   flex: 1;
// //   display: flex;
// //   flex-direction: column;

// //   > form {
// //     flex: 1;
// //     font-size: 14px;
// //     color: #2c405a;

// //     label {
// //       font-size: 12px;
// //       color: #2c405a;
// //       font-weight: bolder;
// //       text-transform: uppercase;
// //     }

// //     > strong {
// //       font-size: 16px;
// //     }

// //     > p {
// //       border-radius: 5px;
// //       background: #f8f8f8;
// //       padding: 5px 10px;
// //       color: rgba(44, 64, 90, 0.5);
// //       text-align: center;
// //       font-size: 12px;
// //       margin-top: 5px;
// //     }
// //   }
// // `;

// // Content.Form.Error = styled.span`
// //   width: 100%;
// //   text-align: center;
// //   color: #e95938;
// //   font-style: italic;
// //   font-size: 12px;
// // `;

// // Content.Form.Quantity = styled.div`
// //   display: flex;
// //   align-items: center;
// //   width: 100%;

// //   > div {
// //     display: flex;
// //     flex: 1;
// //     justify-content: center;

// //     input {
// //       text-align: center;
// //     }

// //     > button {
// //       border: 0;
// //       background: none;
// //       margin: 0 10px;
// //       padding: 5px 10px;
// //     }
// //   }
// // `;

// // // export const WrapperUpdatePN = styled.div`
// // //   border-top: 1px solid #ccc;
// // //   padding-top: 20px;
// // //   margin-top: 5px;
// // //   display: flex;
// // //   flex: 1;
// // //   flex-direction: column;
// // //   align-items: flex-start;
// // //   justify-content: center;
// // //   align-content: center;

// // //   p {
// // //     font-size: 12px;
// // //     letter-spacing: 1.2px;
// // //     padding-bottom: 8px;
// // //   }

// // //   h4 {
// // //     padding: 0 20px;
// // //     margin-bottom: 20px;
// // //   }

// // //   input {
// // //     margin: 0 20px;
// // //     border: none;
// // //     border-bottom: 2px solid #ccc;
// // //     padding: 1px 5px;
// // //     min-width: 250px;

// // //     ::placeholder {
// // //       color: #ccc;
// // //     }
// // //   }
// // // `;

// // export const ButtonUpdatePN = styled.button`
// //   display: flex;
// //   align-items: center;
// //   justify-content: center;
// //   /* width: 100%; */
// //   /* padding: 10px;
// //   margin: 10px auto; */
// //   border: none;
// //   /* background: #64748b;
// //   color: #f8fafc; */
// //   color: #64748b;
// //   background: transparent;
// //   /* border-radius: 5px; */
// // `;

// // export const WrapperUpdatePN = styled.div`
// //   border-top: 1px solid #e5e5e5;
// //   padding-top: 24px;
// //   margin-top: 12px;

// //   display: flex;
// //   flex-direction: column;
// //   gap: 22px;

// //   width: 100%;

// //   .current-box {
// //     background: #f8f9fa;
// //     border: 1px solid #e2e5e9;
// //     border-radius: 10px;
// //     padding: 14px 16px;

// //     display: flex;
// //     flex-direction: column;
// //     gap: 6px;
// //   }

// //   .current-box span {
// //     font-size: 11px;
// //     color: #777;
// //     text-transform: uppercase;
// //     letter-spacing: 1px;
// //     font-weight: 600;
// //   }

// //   .current-box strong {
// //     font-size: 16px;
// //     color: #333;
// //     word-break: break-all;
// //   }

// //   .form-group {
// //     display: flex;
// //     flex-direction: column;
// //     gap: 8px;
// //   }

// //   label {
// //     font-size: 12px;
// //     color: #555;
// //     text-transform: uppercase;
// //     letter-spacing: 1px;
// //     font-weight: 600;
// //   }

// //   input {
// //     width: 100%;
// //     min-width: 280px;

// //     border: 1px solid #ddd;
// //     border-radius: 8px;

// //     padding: 12px 14px;

// //     font-size: 14px;
// //     color: #333;

// //     background: #fff;

// //     transition: border-color 0.2s ease, box-shadow 0.2s ease;
// //   }

// //   input::placeholder {
// //     color: #aaa;
// //   }

// //   input:focus {
// //     outline: none;
// //     border-color: #4a90e2;
// //     box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.15);
// //   }

// //   .actions {
// //     display: flex;
// //     justify-content: flex-end;
// //     gap: 10px;

// //     margin-top: 4px;
// //   }

// //   .actions button {
// //     background: #4a90e2;
// //     color: #fff;

// //     border: none;
// //     border-radius: 8px;

// //     padding: 10px 16px;

// //     font-size: 13px;
// //     font-weight: 600;

// //     cursor: pointer;

// //     transition: filter 0.2s ease, transform 0.1s ease;
// //   }

// //   .actions button:hover {
// //     filter: brightness(0.95);
// //   }

// //   .actions button:active {
// //     transform: scale(0.98);
// //   }

// //   .actions .cancel {
// //     background: #f1f1f1;
// //     color: #555;
// //   }

// //   .actions .confirm {
// //     background: #4a90e2;
// //     color: #fff;
// //   }

// //   @media (max-width: 480px) {
// //     input {
// //       min-width: 100%;
// //     }

// //     .actions {
// //       flex-direction: column-reverse;
// //     }

// //     .actions button {
// //       width: 100%;
// //     }
// //   }
// // `;

// import styled from 'styled-components';
// import { darken } from 'polished';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --primary: #ff6d3c (gradiente)   --blue: #1789dd
//    --ink: #2c405a / #17263b   --muted: #64748b
//    --border: rgba(216, 224, 235, 0.9)
// =========================================================== */

// const PRIMARY_GRADIENT =
//   'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

// export const CartModal = styled.div.attrs((props) => ({
//   style: {
//     top: `${props.top}px`,
//     left: `${props.left}px`,
//   },
// }))`
//   position: absolute;
//   min-width: 400px;
//   min-height: 250px;
//   z-index: 5;

//   display: flex;
//   flex-direction: column;
//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 14px;
//   box-shadow: 0 24px 60px rgba(23, 38, 59, 0.22),
//     0 1px 0 rgba(255, 255, 255, 0.9) inset;

//   color: #2c405a;
// `;

// export const WrapperItemOS = styled.div`
//   margin: 10px 0;
//   padding: 12px;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 12px;
//   box-shadow: 0 6px 16px rgba(23, 38, 59, 0.06);
// `;

// export const SubtitleItemOS = styled.span`
//   color: #1789dd !important;
//   font-weight: bold;
//   padding: 10px;
// `;

// export const Content = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   padding: 30px 25px 25px;
//   position: relative;
// `;

// Content.Move = styled.span`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   margin: 0 auto;

//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 80px;
//   color: #cbd0d8;
//   transition: color 0.2s ease;
//   cursor: grab;

//   :hover {
//     color: #ff6d3c;
//   }

//   :active {
//     cursor: grabbing;
//   }
// `;

// Content.BtnClose = styled.button`
//   position: absolute;
//   top: 0;
//   right: 0;
//   margin: 6px;
//   height: 32px;
//   width: 32px;

//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border: 0;
//   border-radius: 10px;
//   background: none;
//   color: #cbd0d8;
//   cursor: pointer;
//   transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

//   :hover {
//     color: ${darken(0.1, '#cbd0d8')};
//     background: rgba(44, 64, 90, 0.06);
//     transform: rotate(90deg);
//   }
// `;

// Content.BtnAddCart = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   height: 42px;
//   border: 0;
//   border-radius: 12px;
//   background: ${PRIMARY_GRADIENT};
//   color: #fff;
//   font-weight: 800;
//   cursor: pointer;
//   box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
//   transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

//   > svg {
//     margin-right: 5px;
//   }

//   :hover {
//     transform: translateY(-1px);
//     box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
//     filter: brightness(1.02);
//   }

//   :active {
//     transform: translateY(0);
//   }
// `;

// Content.Title = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   color: #2c405a;

//   user-select: text;

//   > strong {
//     font-size: 16px;
//     color: #17263b;
//   }
// `;

// Content.Title.Espec = styled.span`
//   color: rgba(44, 64, 90, 0.5);
//   font-style: italic;
// `;

// Content.Title.Hist = styled.span`
//   color: rgba(44, 64, 90, 0.5);
// `;

// Content.Title.Note = styled.div`
//   border-radius: 8px;
//   background: #f4f7fb;
//   padding: 6px 10px;
//   color: rgba(44, 64, 90, 0.6);
//   text-align: center;
//   font-size: 12px;
//   margin-top: 5px;
// `;

// Content.Form = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;

//   > form {
//     flex: 1;
//     font-size: 14px;
//     color: #2c405a;

//     label {
//       font-size: 11px;
//       color: #4a5b72;
//       font-weight: 800;
//       letter-spacing: 0.5px;
//       text-transform: uppercase;
//     }

//     > strong {
//       font-size: 16px;
//     }

//     > p {
//       border-radius: 8px;
//       background: #f4f7fb;
//       padding: 6px 10px;
//       color: rgba(44, 64, 90, 0.6);
//       text-align: center;
//       font-size: 12px;
//       margin-top: 5px;
//     }
//   }
// `;

// Content.Form.Error = styled.span`
//   width: 100%;
//   text-align: center;
//   color: #e95938;
//   font-style: italic;
//   font-size: 12px;
// `;

// Content.Form.Quantity = styled.div`
//   display: flex;
//   align-items: center;
//   width: 100%;

//   > div {
//     display: flex;
//     flex: 1;
//     justify-content: center;

//     input {
//       text-align: center;
//     }

//     > button {
//       display: inline-flex;
//       align-items: center;
//       justify-content: center;
//       border: 0;
//       border-radius: 9px;
//       background: none;
//       color: #2c405a;
//       margin: 0 10px;
//       padding: 5px 10px;
//       cursor: pointer;
//       transition: color 0.2s ease, background 0.2s ease;

//       :hover {
//         color: #ff6d3c;
//         background: rgba(255, 109, 60, 0.1);
//       }
//     }
//   }
// `;

// export const ButtonUpdatePN = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border: none;
//   color: #64748b;
//   background: transparent;
//   cursor: pointer;
//   transition: color 0.2s ease;

//   :hover {
//     color: #ff6d3c;
//   }
// `;

// export const WrapperUpdatePN = styled.div`
//   border-top: 1px solid rgba(216, 224, 235, 0.9);
//   padding-top: 24px;
//   margin-top: 12px;

//   display: flex;
//   flex-direction: column;
//   gap: 22px;

//   width: 100%;

//   .current-box {
//     background: #f4f7fb;
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     border-radius: 10px;
//     padding: 14px 16px;

//     display: flex;
//     flex-direction: column;
//     gap: 6px;
//   }

//   .current-box span {
//     font-size: 11px;
//     color: #79869e;
//     text-transform: uppercase;
//     letter-spacing: 1px;
//     font-weight: 700;
//   }

//   .current-box strong {
//     font-size: 16px;
//     color: #17263b;
//     word-break: break-all;
//   }

//   .form-group {
//     display: flex;
//     flex-direction: column;
//     gap: 8px;
//   }

//   label {
//     font-size: 12px;
//     color: #4a5b72;
//     text-transform: uppercase;
//     letter-spacing: 1px;
//     font-weight: 700;
//   }

//   input {
//     width: 100%;
//     min-width: 280px;

//     border: 1px solid rgba(216, 224, 235, 0.9);
//     border-radius: 10px;

//     padding: 12px 14px;

//     font-size: 14px;
//     color: #1f2f46;

//     background: #f8fafc;

//     transition: border-color 0.2s ease, box-shadow 0.2s ease,
//       background 0.2s ease;
//   }

//   input::placeholder {
//     color: #98a5b7;
//   }

//   input:focus {
//     outline: none;
//     border-color: #ff6d3c;
//     background: #fff;
//     box-shadow: 0 0 0 4px rgba(255, 109, 60, 0.12);
//   }

//   .actions {
//     display: flex;
//     justify-content: flex-end;
//     gap: 10px;

//     margin-top: 4px;
//   }

//   .actions button {
//     color: #fff;
//     background: ${PRIMARY_GRADIENT};

//     border: none;
//     border-radius: 10px;

//     padding: 10px 16px;

//     font-size: 13px;
//     font-weight: 700;

//     cursor: pointer;

//     transition: filter 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease;
//   }

//   .actions button:hover {
//     filter: brightness(1.02);
//     box-shadow: 0 10px 22px rgba(255, 109, 60, 0.32);
//   }

//   .actions button:active {
//     transform: scale(0.98);
//   }

//   .actions .cancel {
//     background: #eef2f8;
//     color: #4a5b72;
//   }

//   .actions .cancel:hover {
//     background: ${darken(0.05, '#eef2f8')};
//     box-shadow: none;
//   }

//   .actions .confirm {
//     background: ${PRIMARY_GRADIENT};
//     color: #fff;
//   }

//   @media (max-width: 480px) {
//     input {
//       min-width: 100%;
//     }

//     .actions {
//       flex-direction: column-reverse;
//     }

//     .actions button {
//       width: 100%;
//     }
//   }
// `;

// import styled from 'styled-components';
// import { darken } from 'polished';

// export const CartModal = styled.div.attrs((props) => ({
//   style: {
//     top: `${props.top}px`,
//     left: `${props.left}px`,
//   },
// }))`
//   position: absolute;
//   min-width: 400px;
//   min-height: 250px;

//   display: flex;
//   flex-direction: column;
//   box-shadow: 0px 3px 10px #00000033;
//   background: #fff;
//   border-radius: 10px;

//   color: #2c405a;
// `;

// export const WrapperItemOS = styled.div`
//   margin: 10px 0;
//   padding: 10px;
//   border-radius: 5px;
//   box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.1);
// `;

// export const SubtitleItemOS = styled.span`
//   color: #0ea5e9 !important;
//   font-weight: bold;
//   padding: 10px;
// `;

// export const Content = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   padding: 30px 25px 25px;
//   position: relative;
// `;

// Content.Move = styled.span`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   margin: 0 auto;

//   display: flex;
//   align-items: center;
//   justify-content: center;
//   width: 80px;
//   transition: 1s all;
//   cursor: grab;

//   :hover {
//     color: #ff6d3c;
//   }

//   :active {
//     cursor: grabbing;
//   }
// `;

// Content.BtnClose = styled.button`
//   position: absolute;
//   top: 0;
//   right: 0;
//   margin: 2px;
//   height: 30px;
//   width: 30px;

//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: #cbd0d8;
//   border: 0;
//   background: none;
//   transition: 1s all;

//   :hover {
//     color: ${darken(0.05, '#cbd0d8')};
//   }
// `;

// Content.BtnAddCart = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: #ff6d3c;
//   border: 0;
//   border-radius: 5px;
//   color: #fff;
//   height: 40px;
//   transition: background 1s;

//   > svg {
//     margin-right: 5px;
//   }

//   :hover {
//     background: ${darken(0.05, '#ff6d3c')};
//   }
// `;

// Content.Title = styled.div`
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   width: 100%;
//   color: #2c405a;

//   user-select: text;

//   > strong {
//     font-size: 16px;
//   }
// `;

// Content.Title.Espec = styled.span`
//   color: rgba(44, 64, 90, 0.5);
//   font-style: italic;
// `;

// Content.Title.Note = styled.div`
//   border-radius: 5px;
//   background: #f8f8f8;
//   padding: 5px 10px;
//   color: rgba(44, 64, 90, 0.5);
//   text-align: center;
//   font-size: 12px;
//   margin-top: 5px;
// `;

// Content.Form = styled.div`
//   flex: 1;
//   display: flex;
//   flex-direction: column;

//   > form {
//     flex: 1;
//     font-size: 14px;
//     color: #2c405a;

//     label {
//       font-size: 12px;
//       color: #2c405a;
//       font-weight: bolder;
//       text-transform: uppercase;
//     }

//     > strong {
//       font-size: 16px;
//     }

//     > p {
//       border-radius: 5px;
//       background: #f8f8f8;
//       padding: 5px 10px;
//       color: rgba(44, 64, 90, 0.5);
//       text-align: center;
//       font-size: 12px;
//       margin-top: 5px;
//     }
//   }
// `;

// Content.Form.Error = styled.span`
//   width: 100%;
//   text-align: center;
//   color: #e95938;
//   font-style: italic;
//   font-size: 12px;
// `;

// Content.Form.Quantity = styled.div`
//   display: flex;
//   align-items: center;
//   width: 100%;

//   > div {
//     display: flex;
//     flex: 1;
//     justify-content: center;

//     input {
//       text-align: center;
//     }

//     > button {
//       border: 0;
//       background: none;
//       margin: 0 10px;
//       padding: 5px 10px;
//     }
//   }
// `;

// // export const WrapperUpdatePN = styled.div`
// //   border-top: 1px solid #ccc;
// //   padding-top: 20px;
// //   margin-top: 5px;
// //   display: flex;
// //   flex: 1;
// //   flex-direction: column;
// //   align-items: flex-start;
// //   justify-content: center;
// //   align-content: center;

// //   p {
// //     font-size: 12px;
// //     letter-spacing: 1.2px;
// //     padding-bottom: 8px;
// //   }

// //   h4 {
// //     padding: 0 20px;
// //     margin-bottom: 20px;
// //   }

// //   input {
// //     margin: 0 20px;
// //     border: none;
// //     border-bottom: 2px solid #ccc;
// //     padding: 1px 5px;
// //     min-width: 250px;

// //     ::placeholder {
// //       color: #ccc;
// //     }
// //   }
// // `;

// export const ButtonUpdatePN = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   /* width: 100%; */
//   /* padding: 10px;
//   margin: 10px auto; */
//   border: none;
//   /* background: #64748b;
//   color: #f8fafc; */
//   color: #64748b;
//   background: transparent;
//   /* border-radius: 5px; */
// `;

// export const WrapperUpdatePN = styled.div`
//   border-top: 1px solid #e5e5e5;
//   padding-top: 24px;
//   margin-top: 12px;

//   display: flex;
//   flex-direction: column;
//   gap: 22px;

//   width: 100%;

//   .current-box {
//     background: #f8f9fa;
//     border: 1px solid #e2e5e9;
//     border-radius: 10px;
//     padding: 14px 16px;

//     display: flex;
//     flex-direction: column;
//     gap: 6px;
//   }

//   .current-box span {
//     font-size: 11px;
//     color: #777;
//     text-transform: uppercase;
//     letter-spacing: 1px;
//     font-weight: 600;
//   }

//   .current-box strong {
//     font-size: 16px;
//     color: #333;
//     word-break: break-all;
//   }

//   .form-group {
//     display: flex;
//     flex-direction: column;
//     gap: 8px;
//   }

//   label {
//     font-size: 12px;
//     color: #555;
//     text-transform: uppercase;
//     letter-spacing: 1px;
//     font-weight: 600;
//   }

//   input {
//     width: 100%;
//     min-width: 280px;

//     border: 1px solid #ddd;
//     border-radius: 8px;

//     padding: 12px 14px;

//     font-size: 14px;
//     color: #333;

//     background: #fff;

//     transition: border-color 0.2s ease, box-shadow 0.2s ease;
//   }

//   input::placeholder {
//     color: #aaa;
//   }

//   input:focus {
//     outline: none;
//     border-color: #4a90e2;
//     box-shadow: 0 0 0 3px rgba(74, 144, 226, 0.15);
//   }

//   .actions {
//     display: flex;
//     justify-content: flex-end;
//     gap: 10px;

//     margin-top: 4px;
//   }

//   .actions button {
//     background: #4a90e2;
//     color: #fff;

//     border: none;
//     border-radius: 8px;

//     padding: 10px 16px;

//     font-size: 13px;
//     font-weight: 600;

//     cursor: pointer;

//     transition: filter 0.2s ease, transform 0.1s ease;
//   }

//   .actions button:hover {
//     filter: brightness(0.95);
//   }

//   .actions button:active {
//     transform: scale(0.98);
//   }

//   .actions .cancel {
//     background: #f1f1f1;
//     color: #555;
//   }

//   .actions .confirm {
//     background: #4a90e2;
//     color: #fff;
//   }

//   @media (max-width: 480px) {
//     input {
//       min-width: 100%;
//     }

//     .actions {
//       flex-direction: column-reverse;
//     }

//     .actions button {
//       width: 100%;
//     }
//   }
// `;

import styled, { css } from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c (gradiente)   --blue: #1789dd
   --ink: #2c405a / #17263b   --muted: #64748b
   --border: rgba(216, 224, 235, 0.9)
=========================================================== */

const PRIMARY_GRADIENT =
  'linear-gradient(135deg, #ff6d3c 0%, #ff875f 52%, #ff9b78 100%)';

/**
 * ===== Modal do item =====
 * Antes: position: absolute dentro da ZoomArea (bloco da imagem), o que
 * fazia o modal ser recortado quando o desenho ocupava muito espaço e
 * limitava a área em que podia ser arrastado.
 *
 * Agora: position: fixed e renderizado via portal em document.body
 * (mesmo padrão do HoverImagePortal), portanto disponível na tela inteira,
 * sem recorte por nenhum ancestral com overflow: hidden.
 *
 * Props:
 *  - top / left  : posição em pixels na viewport (arraste)
 *  - centered    : ignora top/left e centraliza (modais secundários)
 *  - posicionado : evita o "salto" no primeiro paint, antes de medir
 */
export const CartModal = styled.div.attrs((props) => ({
  style: props.centered
    ? {}
    : {
        top: `${props.top}px`,
        left: `${props.left}px`,
      },
}))`
  position: fixed;
  z-index: 9999;

  min-width: 400px;
  min-height: 250px;

  /** nunca ultrapassa a tela, mesmo em tablet (1340 x 800) */
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);

  /**
   * overflow permanece visible de propósito: o ModalCriarConjunto é filho
   * direto deste elemento e se posiciona em left: 100%, portanto seria
   * recortado por um overflow: auto/hidden aqui. A rolagem interna fica no
   * Content (abaixo).
   */
  overflow: visible;

  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(23, 38, 59, 0.22),
    0 1px 0 rgba(255, 255, 255, 0.9) inset;

  color: #2c405a;

  ${({ posicionado }) =>
    posicionado === 0 &&
    css`
      visibility: hidden;
    `}

  ${({ centered }) =>
    centered &&
    css`
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`;

export const WrapperItemOS = styled.div`
  margin: 10px 0;
  padding: 12px;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(23, 38, 59, 0.06);
`;

export const SubtitleItemOS = styled.span`
  color: #1789dd !important;
  font-weight: bold;
  padding: 10px;
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 30px 25px 25px;
  position: relative;

  /**
   * Rolagem interna do formulário: garante que o modal respeite o
   * max-height da tela (tablet 1340 x 800) sem recortar o painel de criar
   * conjunto, que fica fora deste elemento.
   */
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

Content.Move = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;

  display: flex;
  align-items: center;
  justify-content: center;

  /** alvo de toque mais confortável para arrastar o modal em tablet */
  width: 96px;
  height: 26px;
  color: #cbd0d8;
  transition: color 0.2s ease;
  cursor: grab;

  /** necessário para o arraste por toque via Pointer Events */
  touch-action: none;

  :hover {
    color: #ff6d3c;
  }

  :active {
    cursor: grabbing;
  }
`;

Content.BtnClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  margin: 6px;
  height: 32px;
  width: 32px;

  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  background: none;
  color: #cbd0d8;
  cursor: pointer;
  transition: color 0.2s ease, background 0.2s ease, transform 0.2s ease;

  :hover {
    color: ${darken(0.1, '#cbd0d8')};
    background: rgba(44, 64, 90, 0.06);
    transform: rotate(90deg);
  }
`;

Content.BtnAddCart = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  border: 0;
  border-radius: 12px;
  background: ${PRIMARY_GRADIENT};
  color: #fff;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 12px 26px rgba(255, 109, 60, 0.3);
  transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

  > svg {
    margin-right: 5px;
  }

  :hover {
    transform: translateY(-1px);
    box-shadow: 0 16px 32px rgba(255, 109, 60, 0.42);
    filter: brightness(1.02);
  }

  :active {
    transform: translateY(0);
  }
`;

Content.Title = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #2c405a;

  user-select: text;

  > strong {
    font-size: 16px;
    color: #17263b;
  }
`;

Content.Title.Espec = styled.span`
  color: rgba(44, 64, 90, 0.5);
  font-style: italic;
`;

Content.Title.Hist = styled.span`
  color: rgba(44, 64, 90, 0.5);
`;

Content.Title.Note = styled.div`
  border-radius: 8px;
  background: #f4f7fb;
  padding: 6px 10px;
  color: rgba(44, 64, 90, 0.6);
  text-align: center;
  font-size: 12px;
  margin-top: 5px;
`;

Content.Form = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  > form {
    flex: 1;
    font-size: 14px;
    color: #2c405a;

    label {
      font-size: 11px;
      color: #4a5b72;
      font-weight: 800;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }

    > strong {
      font-size: 16px;
    }

    > p {
      border-radius: 8px;
      background: #f4f7fb;
      padding: 6px 10px;
      color: rgba(44, 64, 90, 0.6);
      text-align: center;
      font-size: 12px;
      margin-top: 5px;
    }
  }
`;

Content.Form.Error = styled.span`
  width: 100%;
  text-align: center;
  color: #e95938;
  font-style: italic;
  font-size: 12px;
`;

Content.Form.Quantity = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  > div {
    display: flex;
    flex: 1;
    justify-content: center;

    input {
      text-align: center;
    }

    > button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 0;
      border-radius: 9px;
      background: none;
      color: #2c405a;
      margin: 0 10px;
      padding: 5px 10px;
      cursor: pointer;
      transition: color 0.2s ease, background 0.2s ease;

      :hover {
        color: #ff6d3c;
        background: rgba(255, 109, 60, 0.1);
      }
    }
  }
`;

export const ButtonUpdatePN = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #64748b;
  background: transparent;
  cursor: pointer;
  transition: color 0.2s ease;

  :hover {
    color: #ff6d3c;
  }
`;

export const WrapperUpdatePN = styled.div`
  border-top: 1px solid rgba(216, 224, 235, 0.9);
  padding-top: 24px;
  margin-top: 12px;

  display: flex;
  flex-direction: column;
  gap: 22px;

  width: 100%;

  .current-box {
    background: #f4f7fb;
    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;
    padding: 14px 16px;

    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .current-box span {
    font-size: 11px;
    color: #79869e;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
  }

  .current-box strong {
    font-size: 16px;
    color: #17263b;
    word-break: break-all;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  label {
    font-size: 12px;
    color: #4a5b72;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
  }

  input {
    width: 100%;
    min-width: 280px;

    border: 1px solid rgba(216, 224, 235, 0.9);
    border-radius: 10px;

    padding: 12px 14px;

    font-size: 14px;
    color: #1f2f46;

    background: #f8fafc;

    transition: border-color 0.2s ease, box-shadow 0.2s ease,
      background 0.2s ease;
  }

  input::placeholder {
    color: #98a5b7;
  }

  input:focus {
    outline: none;
    border-color: #ff6d3c;
    background: #fff;
    box-shadow: 0 0 0 4px rgba(255, 109, 60, 0.12);
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    margin-top: 4px;
  }

  .actions button {
    color: #fff;
    background: ${PRIMARY_GRADIENT};

    border: none;
    border-radius: 10px;

    padding: 10px 16px;

    font-size: 13px;
    font-weight: 700;

    cursor: pointer;

    transition: filter 0.2s ease, transform 0.1s ease, box-shadow 0.2s ease;
  }

  .actions button:hover {
    filter: brightness(1.02);
    box-shadow: 0 10px 22px rgba(255, 109, 60, 0.32);
  }

  .actions button:active {
    transform: scale(0.98);
  }

  .actions .cancel {
    background: #eef2f8;
    color: #4a5b72;
  }

  .actions .cancel:hover {
    background: ${darken(0.05, '#eef2f8')};
    box-shadow: none;
  }

  .actions .confirm {
    background: ${PRIMARY_GRADIENT};
    color: #fff;
  }

  @media (max-width: 480px) {
    input {
      min-width: 100%;
    }

    .actions {
      flex-direction: column-reverse;
    }

    .actions button {
      width: 100%;
    }
  }
`;
